module.exports = __webpack_public_path__ + "static/media/BW.228240d5.svg";